import React, { useState, useEffect, useRef } from 'react';
import { DataGridPro, GridToolbarContainer, GridToolbarExport, GridToolbarQuickFilter, GridActionsCellItem, useGridApiRef, GridFooter } from '@mui/x-data-grid-pro';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Modal from 'react-bootstrap/Modal';
import { FaChevronDown } from 'react-icons/fa';
import { VscFolderActive } from 'react-icons/vsc';
import { ToastContainer } from 'react-toastify';
import { ListsModal, ObjModal } from '../../contexts';
import AddEvent from '../../components/Modals/AddEvent';
import SendTxt from '../../components/Modals/SendTxt';
import SendEmail from '../../components/Modals/SendEmail';
// import Toolbar from '../../containers/Grid/Toolbar';
import LogComms from '../../components/Modals/LogComms';
import SendMassEmail from '../../components/Modals/SendMassEmail';
import EmailIcon from '@mui/icons-material/Email';
import TextsmsIcon from '@mui/icons-material/Textsms';
import ScheduleIcon from '@mui/icons-material/Schedule';
import CallIcon from '@mui/icons-material/Call';
import DeleteIcon from '@mui/icons-material/Delete';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import NamesInGrid from './NamesInGrid';
import TFObject from '../../components/TFObject';

import "react-toastify/dist/ReactToastify.css";
import '../../containers/Dashboard/dashboard.css';

const Tasks2 = ( { aid, uid, user, viewing, tasks, contacts, status, meta } ) => {
    const [ gridHeight, setGridHeight ] = useState( 0 );
    const [ containerBuffer, setContainerBuffer ] = useState( 125 );

    const [show, setShow] = useState( false );
    const closeModal = () => setShow( false );
    const openModal = () => setShow( true );
    const [ modal, setModal ] = useState();
    const [ loading, setLoading ] = useState( true );
    const [ tList, setTasks ] = useState( [] );
    const [ selectedTid, setSelectedTid ] = useState( '' );
    const [ selectedRows, setSelectedRows ] = useState( [] );
    
    let cols = [
        { field: 'name', headerName: 'Subject', width: 200, renderCell: ( params ) => <Link to={ '#' } onClick={ () => setSelectedTid( params.row.id ) }>{params.value}</Link> },
        { 
            field: 'assoc', 
            headerName: 'Contact', 
            width: 175, 
            renderCell: ( params ) => <NamesInGrid row={params.row} />, 
            valueGetter: ( params ) => {
                let v = [];
                params.row.assoc.forEach( b => {
                    if ( b ) {
                        const c = contacts[b.cid]; // cl.find( f => f.cid === b.cid );
                        if ( c ) { v.push( c.name ); }
                    }
                } );
                return v.join( ', ' );
            }
        },
        { field: 'dueDate', headerName: 'Due', type: 'date', width: 100, valueGetter: ( { value } ) => value && new Date( value + 'T12:00:00' ).toLocaleDateString() },
        { field: 'type', headerName: 'Type', width: 100 },
        { field: 'assignedTo', headerName: 'Assigned To', width: 150 }
    ];

    const containerRef = useRef();
    const titleRef = useRef();
    
    const gridRef = useGridApiRef();

    const toolbar = () => {
        return(
            <GridToolbarContainer>
                <Container fluid className='p-0'>
                    <Row className='p-0 align-items-center'>
                        <Col>
                            <Row className='text-start align-items-center'>
                                <Col xs='auto' className='pe-0'>
                                    <GridFooter className='tf-fake-footer' />
                                </Col>
                                <Col>
                                    { 
                                        selectedRows.length > 0 &&
                                        <Row style={ { borderLeft: '1px solid #CCC' } }>
                                            <Col xs='auto' className='pe-2'>Take Action...</Col>
                                            <Col xs='auto' className='ps-0'>
                                                <DropdownButton size='sm' title={<FaChevronDown />} className='tf-button-transparent tf-hide-arrow'>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'email-mass' ) }>Send Email</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'sms-mass' ) }>Send Txt</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'phoneburner' ) }>Launch Phoneburner</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'list' ) }>Add to a List</Dropdown.Item>
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'event' ) }>Add to an Event</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'reschedule' ) }>Remind Me Tomorrow</Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item onClick={ () => handleMassModal( 'delete' ) }>Delete</Dropdown.Item>
                                                </DropdownButton>
                                            </Col>
                                        </Row>
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    <Row className='p-0 align-items-center'>
                        <Col className='text-left'>
                            <GridToolbarQuickFilter />
                        </Col>
                        {/* <Col xs='auto' className='pe-3 text-right'>
                            <GridToolbarExport />
                        </Col> */}
                    </Row>
                </Container>
            </GridToolbarContainer>
        )
    }

    const handleSingleModal = ( t, cid ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'log-call':
                console.log( 'log-call w/ cid: ' + cid );
                setModal( <LogComms commType='Call' close={closeModal} cid={cid} /> );
                break;

            default:
                shouldOpen = false;
                console.log( 'unknown modeal type for single: ' + t + ' - ' + cid )  ;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleMassModal = ( t ) => {
        let shouldOpen = true;

        let contacts = [];
        selectedRows.forEach( r => {
            console.log( r );
            // const [ loid, cid ] = r.split( '#' );
            // contacts.push( leads.find( f => f.cid === cid ) );
        } );

        switch ( t ) {
            case 'email-mass':
                setModal( <SendMassEmail contacts={ contacts } close={ closeModal } /> ); 
                break;

            case 'sms-mass':
                setModal( <SendTxt contacts={ contacts } close={ closeModal } /> ); 
                break;
    
            case 'phoneburner':
                setModal( <div>phoneburner</div> ); 
                break;
        
            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'email':
                setModal( <SendEmail /> );
                break;

            case 'sms':
                setModal( <SendTxt /> );
                break;

            case 'event':
                setModal( <AddEvent /> );
                break;

            default:
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
        
        console.log( 'modal: ' + t );
    }

    useEffect( () => {
        document.title = 'Third Floor - Tasks';
    }, [ aid, uid ] );
    
    useEffect( () => {
        if ( user.additionalAccounts && user.additionalAccounts.length > 1 ) {
            setContainerBuffer( prev => prev + 30 );
        }
    }, [ user.additionalAccounts ] );

    useEffect( () => {
        setGridHeight( containerRef.current.clientHeight - titleRef.current.clientHeight - 15 );
    }, [ containerBuffer ] );

    useEffect( () => {
        if ( tasks ) {
            const stats = status.filter( s => s.queue === 'open' ).map( m => m.value );
            let list = [];
            Object.keys( tasks ).forEach( tid => {
                const t = tasks[tid];
                if ( !viewing.includes( t.aid ) ) {
                    return;
                }

                if ( t.assignedTo === uid && stats.includes( t.status ) && Date.parse( t.dueDate ) <= Date.now() ) {
                    list.push( {
                        ...t,
                        details: t,
                        assoc: t.assoc
                     } );
                }
            } );
            setTasks( list );
            setLoading( false );
        }
    }, [ tasks, status, uid, viewing ] );

    return (
        <Container fluid className='px-0' style={ { height: '100%' } }>
            <Row className='mx-1' style={ { height: `calc(100vh - ${containerBuffer}px)` } } ref={containerRef}>
                <Col className='tf-section-container mx-2 p-0' xs={4} md={3} style={ { height: '100%' } }>
                    <Row className=''>
                        <Col className=''>
                            <Row className='p-2' ref={titleRef}>
                                <Col>
                                    <VscFolderActive />
                                    <span className='ps-2 fw-bold fs-6'>Tasks</span>
                                </Col>
                            </Row>
                            <Row className='p-0 m-0'>
                                <Col className='p-0' style={ { display: 'flex', height: `${gridHeight}px`, width: '100%' } }>
                                    <ListsModal.Provider value={ { openModal, closeModal, setModal } }>
                                        <DataGridPro
                                            apiRef={gridRef}
                                            loading={ loading }
                                            rows={tList}
                                            columns={cols}
                                            density='compact'
                                            checkboxSelection
                                            disableSelectionOnClick
                                            slots={ { toolbar: toolbar } }
                                            onRowSelectionModelChange={ ( ids ) => setSelectedRows( ids ) }
                                            getRowHeight={ () => 'auto' }
                                            sx={ {
                                                border: 0
                                            } }
                                            hideFooter={true}
                                        />
                                    </ListsModal.Provider>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
                <Col className='tf-section-container mx-2 p-0' style={ { height: '100%' } }>
                    <Row className=''>
                        <Col className=''>
                            <Row className='p-2'>
                                <Col>
                                    {
                                        ( selectedTid && tasks[selectedTid] ) ? (
                                            <TFObject key={selectedTid} objType='task' obj={ { details: tasks[selectedTid] } } oid={selectedTid} objPick={meta.picklist} header={meta.header} details={meta.details} sidebar={meta.sidebar} />
                                        ) : (
                                            <span>No Task Selected Yet.</span>
                                        )
                                    }
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Col>
            </Row>
            <ToastContainer autoClose={3000} />
            <Modal show={show} onHide={closeModal} centered size='lg'>
                {modal}
            </Modal>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    user: state.user,
    viewing: state.user.viewing,
    team: state.user.lists.team,
    tasks: state.tasks.byId,
    contacts: state.contacts.byId,
    status: state.user.meta.task.picklist.status,
    meta: state.user.meta.task
} );
  
const mapDispatch = ( dispatch ) => ( {
} );
  
export default connect( mapProps, mapDispatch )( Tasks2 );